import Button from './Button'
import Input from './Input'
import ActionButton from './ActionButton'
import DatePicker from './DatePicker'
import Checkbox from './Checkbox'
const Controls = {
    Button,
    Input,
    ActionButton,
    DatePicker,
    Checkbox,
}

export default Controls